import PageBreadcrumb from '../../../components/common/PageBreadCrumb';
import PageMeta from '../../../components/common/PageMeta';

/**
 * Shared shell for QC task screens: meta, breadcrumb, responsive content area.
 */
export default function QcPageLayout({
  title,
  metaDescription,
  breadcrumbTitle,
  breadcrumbSubtitle,
  breadcrumbSubtitleExtra,
  breadcrumbTitleAddon,
  children,
}) {
  return (
    <>
      <PageMeta title={`${title} | QC Lite`} description={metaDescription} />
      <PageBreadcrumb
        pageTitle={breadcrumbTitle}
        pageSubtitle={breadcrumbSubtitle}
        pageSubtitleExtra={breadcrumbSubtitleExtra}
        pageTitleAddon={breadcrumbTitleAddon}
        compact
      />
      {/*
        Mobile / small viewports: tighter inset for table width. md+: 40px × 32px (top).
        Bottom padding respects safe-area; smaller minimum on phones.
      */}
      <div className="min-h-[50vh] overflow-x-hidden rounded-2xl border border-gray-200 bg-white px-3 pt-3 pb-[max(0.625rem,env(safe-area-inset-bottom,0px))] dark:border-gray-800 dark:bg-white/[0.03] sm:px-4 sm:pt-4 md:px-[40px] md:pt-[32px] md:pb-[max(2rem,env(safe-area-inset-bottom,0px))]">
        {children}
      </div>
    </>
  );
}
